module.exports = __webpack_public_path__ + "static/Syberia0-176b53d0c5e3ee09b8834db65bd4ab48.png";